import { createReducer } from '@reduxjs/toolkit';
import {
    clearMessages,
    getSubscriptionDurationStart, getSubscriptionDurationSuccess, getSubscriptionDurationFailure,
    getAllSubscriptionsStart, getAllSubscriptionsSuccess, getAllSubscriptionsFailure,
    updateSubscriptionStart, updateSubscriptionSuccess, updateSubscriptionFailure,
    removeSubscriptionStart, removeSubscriptionSuccess, removeSubscriptionFailure,
} from './subscriptionActions';

const initialState = {
    subscriptionDurations: [],
    subscriptions: [],
    loading: false,
    successMessage: null,
    errorMessage: null,
};

const subscriptionReducer = createReducer(initialState, (builder) => {
    builder

        // Clear messages
        .addCase(clearMessages, (state) => {
            state.successMessage = null;
            state.errorMessage = null;
        })

        // Get Subscription Duration
        .addCase(getSubscriptionDurationStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getSubscriptionDurationSuccess, (state, action) => {
            state.loading = false;
            state.subscriptionDurations = action.payload.data;
        })
        .addCase(getSubscriptionDurationFailure, (state, action) => {
            state.loading = false;
        })

        // Get All Subscriptions
        .addCase(getAllSubscriptionsStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getAllSubscriptionsSuccess, (state, action) => {
            state.loading = false;
            state.subscriptions = action.payload.data;
        })
        .addCase(getAllSubscriptionsFailure, (state, action) => {
            state.loading = false;
        })

        // Update Subscription
        .addCase(updateSubscriptionStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(updateSubscriptionSuccess, (state, action) => {
            state.loading = false;
            state.successMessage = action.payload.message;
        })
        .addCase(updateSubscriptionFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        })

        // Remove Subscription
        .addCase(removeSubscriptionStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(removeSubscriptionSuccess, (state, action) => {
            state.loading = false;
            state.successMessage = action.payload.message;
        })
        .addCase(removeSubscriptionFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        });
});

export default subscriptionReducer;
